import Seo from "../components/Seo";
import BookNowButton from "../components/BookNowButton";
import { HOTEL, ROOMS, formatPrice } from "../data/site";

export default function Rooms() {
  return (
    <main className="rooms-wrap">
      <Seo
        title="Rooms & Rates — Hotel Gill Tower, Hanumangarh"
        description="Browse the rooms at Hotel Gill Tower, Hanumangarh — single, double, twin and family rooms with photos and prices per night. Book your stay on WhatsApp."
      />
      <div className="container page-head">
        <p className="eyebrow">Rooms &amp; Rates</p>
        <h1>Rooms at Hotel Gill Tower</h1>
        <p className="page-head-sub">
          All prices are per night. To book, tap Book Now and message us on
          WhatsApp.
        </p>
      </div>
      <div className="container rooms-list">
        {ROOMS.map((room, i) => (
          <section
            className={`room-row ${i % 2 === 1 ? "reverse" : ""}`}
            key={room.id}
            data-testid={`room-section-${room.id}`}
          >
            <img className="room-photo" src={room.image} alt={room.alt} loading="lazy" />
            <div className="room-info">
              <h2>{room.name}</h2>
              <p className="room-price">
                {formatPrice(room.price)} <span className="per">per night</span>
              </p>
              <BookNowButton testId={`book-now-room-${room.id}`} />
            </div>
          </section>
        ))}
        <div className="rooms-cta" data-testid="rooms-cta">
          <p className="rooms-cta-text">
            Book your room at Hotel Gill Tower — message us on WhatsApp or find
            us on Google Maps.
          </p>
          <div className="hero-actions">
            <BookNowButton testId="book-now-rooms-page" />
            <a
              className="btn-outline"
              href={HOTEL.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="rooms-maps-link"
            >
              Google Maps
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}
